<template>
  <Layout>
    <div class="card" style="min-height: 80vh">
      <div class="card-header">
        <h3 class="text-uppercase mb-0">{{ $t("t_manager_region") }}</h3>
        <div class="text-end">
          <div class="btn-header">
            <button
              class="btn btn-soft-secondary btn-border me-2"
              @click="fn_showFormTimKiem()"
            >
              <i class="ri-search-line"></i>
              {{ $t("t-search") }}
            </button>
            <button
              class="btn btn-secondary btn-border"
              @click="fn_handle('create', null)"
              v-if="
                profile_user.roles === 'Admin'
              "
            >
              <i class="ri-add-circle-line"></i>
              {{ $t("t-add") }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body" style="padding: 0 0 15px 0">
        <div class="main-body">
          <div class="main-body-search mx-3 mb-3">
            <b-collapse
              v-model="tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card>
                <el-form
                  label-position="left"
                  ref="ruleFormRef"
                  @submit.prevent
                  :model="tableRules.dataSearch.value"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item :label="$t('t_region_code')">
                        <el-input
                          clearable
                          v-model="tableRules.dataSearch.value['code']"
                          :placeholder="$t('t_place_region_code')"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item :label="$t('t_region_name')">
                        <el-input
                          clearable
                          v-model="tableRules.dataSearch.value['name']"
                          :placeholder="$t('t_place_region_name')"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <a
                        class="btn btn-soft-secondary btn-border waves-effect waves-light mx-3"
                        style="width: 80px"
                        @click="fn_showFormTimKiem()"
                      >
                        {{ $t("t-hide") }}
                      </a>
                      <button
                        class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                        style="width: 100px"
                        native-type="submit"
                        @click="fn_TimKiem()"
                      >
                        {{ $t("t-search") }}
                      </button>
                    </b-col>
                  </b-row>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="mb-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
          <el-table
            size="small"
            :data="dataTables.value"
            style="width: 100%"
            max-height="550"
            v-loading="loading"
            @sort-change="fn_tableSortChange"
            :default-sort="{
              prop: tableRules.defaultSort[0],
              order: tableRules.defaultSort[1],
            }"
          >
            <el-table-column
              prop=""
              :label="$t('t-stt')"
              width="70"
              align="center"
            >
              <template #default="scope">
                <div class="text-center">
                  {{ tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="code"
              :label="$t('t_region_code')"
              min-width="120"
              header-align="center"
              align="left"
              :sortable="true"
            />
            <el-table-column
              prop="name"
              :label="$t('t_region_name')"
              min-width="200"
              header-align="center"
              align="left"
              :sortable="true"
            />
            <el-table-column
              prop="monitor_url"
              :label="$t('t_region_monitor_url')"
              min-width="300"
              header-align="center"
              align="left"
            />
            <el-table-column
              :label="$t('t-action')"
              align="center"
              width="150px"
            >
              <template #default="scope">
                <div class="btn-group-thao-tac">
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_option')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-success waves-effect waves-light btn-sm"
                      @click="fn_handle('update', scope.row)"
                      :disabled="profile_user.roles === 'User'"
                    >
                      <i class="ri-edit-box-line"></i>
                    </button>
                  </el-tooltip>
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_delete')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-danger waves-effect waves-light btn-sm"
                      @click="fn_handle('delete', scope.row)"
                      :disabled="profile_user.roles === 'User'"
                    >
                      <i class="ri-delete-bin-6-line"></i>
                    </button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
        </div>
      </div>

      <!-- Dialog Thêm mới / Cập nhật -->
      <el-dialog
        v-model="showDialog"
        :title="
          typeForm === 'createForm' ? $t('t_add_region') : $t('t_update_region')
        "
        width="550"
        align-center
        :close-on-click-modal="false"
        :before-close="closeDialog"
      >
        <el-form
          ref="regionFormRef"
          :model="formData"
          :rules="currentFormRules"
          label-position="top"
        >
          <el-form-item :label="$t('t_region_code')" prop="code">
            <el-input
              v-model="formData.code"
              :placeholder="$t('t_place_region_code')"
              clearable
              @change="formData.code = formData.code?.trim()"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('t_region_name')" prop="name">
            <el-input
              v-model="formData.name"
              :placeholder="$t('t_place_region_name')"
              clearable
              @change="formData.name = formData.name?.trim()"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('t_region_monitor_url')" prop="monitor_url">
            <el-input
              v-model="formData.monitor_url"
              :placeholder="$t('t_place_region_monitor_url')"
              clearable
              @change="formData.monitor_url = formData.monitor_url?.trim()"
            ></el-input>
          </el-form-item>
          <el-form-item prop="local">
            <el-checkbox
              v-model="formData.local"
              :label="$t('t_region_local')"
            />
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="closeDialog">{{ $t("t-cancel") }}</el-button>
            <el-button type="primary" @click="submitForm" :loading="submitting">
              {{ typeForm === "createForm" ? $t("t-add") : $t("t-update") }}
            </el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </Layout>
</template>

<script setup>
import Layout from "../../layouts/main.vue";
import { onMounted, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import MethodService from "../../service/MethodService";
import mushroom from "cem-primary-api";
import Swal from "sweetalert2";
import toastr from "toastr";
import { profileUserStore } from "../../stores/profileUser";
import { useI18n } from "vue-i18n";
import { Filter, Project } from "mushroomjs";

const { t } = useI18n();
const profile_user = profileUserStore();
const router = useRouter();
const route = useRoute();

let loading = ref(true);
const pageSizeDefault = ref(20);
const showDialog = ref(false);
const typeForm = ref("createForm");
const submitting = ref(false);
const regionFormRef = ref(null);
const editingId = ref("");

const tableRules = reactive({
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "code",
  defaultSort: ["code", "ascending"],
  fields: "id,code,name,monitor_url,local",
  filters: "",
  dataSearch: {
    value: {
      code: "",
      name: "",
    },
    operator: {
      code: ":regex_i:",
      name: ":regex_i:",
    },
  },
});

const dataTables = reactive({ value: [] });

const formData = reactive({
  code: "",
  name: "",
  monitor_url: "",
  local: false,
});

const validateMonitorUrl = (rule, value, callback) => {
  if (value && value.trim() !== "") {
    if (
      !value.trim().startsWith("https://") &&
      !value.trim().startsWith("http://")
    ) {
      callback(new Error(t("t_region_monitor_url_invalid")));
    } else {
      callback();
    }
  } else {
    callback();
  }
};

const formRulesCreate = reactive({
  code: [
    {
      required: true,
      message: () => t("valid_required"),
      trigger: "blur",
    },
  ],
  name: [
    {
      required: true,
      message: () => t("valid_required"),
      trigger: "blur",
    },
  ],
  monitor_url: [
    {
      required: true,
      message: () => t("valid_required"),
      trigger: "blur",
    },
    {
      validator: validateMonitorUrl,
      trigger: "blur",
    },
  ],
});

const formRulesUpdate = reactive({
  code: [],
  name: [],
  monitor_url: [
    {
      validator: validateMonitorUrl,
      trigger: "blur",
    },
  ],
});

const currentFormRules = ref(formRulesCreate);

const fn_showFormTimKiem = () => {
  tableRules.showFormSearch = !tableRules.showFormSearch;
  router
    .replace(MethodService.routerReplace("Region", tableRules))
    .catch(() => {});
};

const fn_TimKiem = () => {
  if (tableRules.dataSearch.value["code"]) {
    tableRules.dataSearch.value["code"] =
      tableRules.dataSearch.value["code"].trim();
  }
  if (tableRules.dataSearch.value["name"]) {
    tableRules.dataSearch.value["name"] =
      tableRules.dataSearch.value["name"].trim();
  }
  tableRules.filters = MethodService.filterTable(
    JSON.stringify(tableRules.dataSearch),
  );
  tableRules.offset = 0;
  tableRules.sort = "";
  getRegions();
};

const fn_tableSizeChange = (limit) => {
  tableRules.limit = limit;
  pageSizeDefault.value = limit;
  fn_tableChangeOffset(tableRules.page);
};

const fn_tableCurentChange = (page) => {
  fn_tableChangeOffset(page);
};

const fn_tablePrevClick = (page) => {
  fn_tableChangeOffset(page - 1);
};

const fn_tableNextClick = (page) => {
  fn_tableChangeOffset(page + 1);
};

const fn_tableChangeOffset = (page) => {
  tableRules.page = page;
  tableRules.offset = (tableRules.page - 1) * pageSizeDefault.value;
  getRegions();
};

const fn_tableSortChange = (column) => {
  MethodService.tableSortChange(column, tableRules);
  loading.value = true;
  getRegions();
};

const fn_hashUrl = () => {
  MethodService.hashUrl(route.query, tableRules);
  pageSizeDefault.value = tableRules.limit;
};

const fn_handle = (type, row) => {
  if (type === "create") {
    typeForm.value = "createForm";
    formData.code = "";
    formData.name = "";
    formData.monitor_url = "";
    formData.local = false;
    editingId.value = "";
    currentFormRules.value = formRulesCreate;
    showDialog.value = true;
  }
  if (type === "update") {
    typeForm.value = "updateForm";
    editingId.value = row.id;
    formData.code = row.code;
    formData.name = row.name;
    formData.monitor_url = row.monitor_url || "";
    formData.local = !!row.local;
    currentFormRules.value = formRulesUpdate;
    showDialog.value = true;
  }
  if (type === "delete") {
    Swal.fire({
      title: t("swal_noti"),
      text: t("t_noti_delete_region"),
      icon: "warning",
      confirmButtonColor: "#f46a6a",
      confirmButtonText: t("swal_accept"),
      cancelButtonText: t("swal_cancel"),
      showCancelButton: true,
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteRegion(row.id);
      }
    });
  }
};

const closeDialog = () => {
  showDialog.value = false;
  regionFormRef.value?.resetFields();
};

const submitForm = async () => {
  if (!regionFormRef.value) return;
  await regionFormRef.value.validate(async (valid) => {
    if (!valid) return;

    submitting.value = true;
    if (typeForm.value === "createForm") {
      await createRegion();
    } else {
      await updateRegion();
    }
    submitting.value = false;
  });
};

const createRegion = async () => {
  try {
    const body = {
      code: formData.code.trim(),
      name: formData.name.trim(),
      monitor_url: formData.monitor_url.trim(),
      local: !!formData.local
    };
    const response = await mushroom.region.createAsync(body);
    if (response.result) {
      toastr.success(t("toastr_add_success"));
      closeDialog();
      await getRegions();
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
    if (e.code === 401 && e.meta?.field) {
      closeDialog();
      Swal.fire({
        title: t("swal_noti"),
        text: t("t_region_unique_key_violation"),
        icon: "warning",
        confirmButtonText: t("swal_accept"),
        allowOutsideClick: false,
      });
    } else {
      MethodService.showError(e.code);
    }
  }
};

const updateRegion = async () => {
  try {
    const body = {
      id: editingId.value,
      code: formData.code.trim(),
      name: formData.name.trim(),
      monitor_url: formData.monitor_url.trim() || null,
      local: !!formData.local
    };
    const response = await mushroom.region.partialUpdateAsync(body);
    if (response.result) {
      toastr.success(t("toastr_update_success"));
      closeDialog();
      await getRegions();
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
    if (e.code === 401 && e.meta?.field) {
      closeDialog();
      Swal.fire({
        title: t("swal_noti"),
        text: t("t_region_unique_key_violation"),
        icon: "warning",
        confirmButtonText: t("swal_accept"),
        allowOutsideClick: false,
      });
    } else {
      MethodService.showError(e.code);
    }
  }
};

const deleteRegion = async (id) => {
  try {
    const response = await mushroom.region.deleteAsync({
      id: id,
    });
    if (response.result) {
      toastr.success(t("toastr_delete_success"));
      await getRegions();
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
    if (e.code === 250800304 && e.meta?.region_user_ids?.length > 0) {
      try {
        // Lấy danh sách region_user từ region_user_ids
        const regionUsers = await mushroom.region_user.getAllAsync({
          filters: Filter.in("id", e.meta.region_user_ids).build(),
          project: Project.include("id", "user_id").build(),
        });
        const userIds = regionUsers.result.map((item) => item.user_id);

        // Lấy thông tin account của các user
        let accountList = [];
        if (userIds.length > 0) {
          const users = await mushroom.user.listAsync({
            filters: `id:in:${userIds.join(",")}`,
            fields: "id,account",
          });
          accountList = users.result.map((item) => item.account);
        }

        const accountHtml = accountList.length > 0
          ? `<ul style="text-align: left; margin-top: 8px;">${accountList.map((acc) => `<li>${acc}</li>`).join("")}</ul>`
          : "";

        Swal.fire({
          title: t("swal_noti"),
          html: `<p>${t("t_region_delete_in_use")}</p>${accountHtml}`,
          icon: "warning",
          confirmButtonText: t("swal_accept"),
          allowOutsideClick: false,
        });
      } catch (innerErr) {
        console.error("Lỗi khi lấy thông tin user: %o", innerErr);
        Swal.fire({
          title: t("swal_noti"),
          text: t("t_region_has_users"),
          icon: "warning",
          confirmButtonText: t("swal_accept"),
          allowOutsideClick: false,
        });
      }
    } else {
      MethodService.showError(e.code);
    }
  }
};

const getRegions = async () => {
  let dataFilter = {
    filters: tableRules.filters,
    fields: tableRules.fields,
    limit: tableRules.limit,
    offset: tableRules.offset,
    sort: tableRules.sort,
  };
  router
    .replace(MethodService.routerReplace("Region", tableRules))
    .catch(() => {});
  try {
    const response = await mushroom.region.listAsync(dataFilter);
    if (response.result) {
      dataTables.value = response.result;
      tableRules.total = response.meta.total;
      tableRules.page = response.meta.offset / response.meta.limit + 1;
    }
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  fn_hashUrl();
  await getRegions();
});
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: center;
}
</style>
